export default "__VITE_ASSET__cb219a71__"